<template>
    <div class="wrap">
        <van-sticky>
            <div class="header">
                <NavigateBar title="我的作业" @handleBack="handleBack"/>
            </div>
            <div class="search-box">
                <van-search
                    v-model="keyword"
                    shape="round"
                    @search="handleSearchHomework"
                    @clear="handleSearchHomework"
                    placeholder="搜索课程名称" />
            </div>
        </van-sticky>
        <div class="main" ref="main">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :style="{ minHeight: listHeight + 'px' }">
                <div class="homework-item" v-for="item of homeworkList" :key="item.class_id" @click="toDetail(item)">
                    <div class="homework-item-image">
                        <img :src="item.course_cover || require('@/assets/img/4.png')" alt="">
                    </div>
                    <div class="homework-item-content">
                        <div class="homework-item-title">
                            <div class="chapter clamp2">{{ item.course_name }}</div>
                            <div class="section clamp2">班期：{{ item.class_name }}</div>
                        </div>
                        <div class="homework-item-message">
                            待完成作业数：
                            <span>{{ item.uncompleted_tasks }}</span>
                        </div>
                    </div>
                    <div class="dot" v-if="item.unread_count > 0"></div>
                </div>
                <van-empty v-if="!homeworkList.length" description="暂无课程数据" />
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
import NavigateBar from './navigateBar.vue';
import Vue from 'vue'
import { Search, PullRefresh, Sticky, Empty } from 'vant'
Vue.use(Search, PullRefresh, Sticky, Empty)

export default {
    components:{
        NavigateBar
    },
    data() {
        return {
            value:'',
            homeworkList:[],
            keyword:'',
            page:1,
            pageSize:'',
            insertmoblie:0,
            isLoading: false,
            innerHeight: null
        }
    },
    mounted(){
        window.addEventListener('scroll',this.handleScroll,true)
    },
    beforeDestroy(){
        window.removeEventListener("scroll",this.handleScroll,true)
    },
    created(){
        this.insertmoblie = this.$route.query.insertmoblie;
        this.innerHeight = window.innerHeight;
        if(this.$route.query.moblie){
        this.moblieType = this.$route.query.moblie
        }
        if(this.$route.query.insertmoblie == 1){
        localStorage.setItem('token',this.$route.query.token)
        }
        this.getHomeworkList()
    },
    computed:{
        listHeight() {
         return this.innerHeight -  50 - 10
       }
    },
    methods: {
        async getHomeworkList(){
            const data = {
                page:this.page,
                page_nums: 10
            }
            if(this.keyword){
                data.keyword = this.keyword
            }
            const res = await this.$api.post('/user/index/homeworkListByClass',data)
            this.pageSize = (res.data.data.count>10?Math.ceil(res.data.data.count/10):1)
            this.homeworkList = [...this.homeworkList, ...res.data.data.list]
        
        },
        handleScroll(){
            let dom = window.document.documentElement || window.document.body
            //文档内容实际高度（包括超出视窗的溢出部分）
            let scrollHeight = Math.max(dom.scrollHeight, dom.scrollHeight);
            //滚动条滚动距离
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //窗口可视范围高度
            let clientHeight = dom.innerHeight || Math.min(dom.clientHeight,dom.clientHeight);
            if(clientHeight + scrollTop+10 >= scrollHeight){
                if(this.page >= this.pageSize ) return
                this.page++
                this.getHomeworkList()
            }
        },
        handleSearchHomework(){
            this.homeworkList = []
            this.page = 1    
            this.getHomeworkList()
        },
        handleBack(){
            this.$router.go(-1)
        },
        toDetail(item) {
            sessionStorage.removeItem('cacheHomework')
            this.$router.push({path:'/chapterIndex', query:{class_id:item.class_id, course_id:item.course_id, className: item.class_name }})
        },
        onRefresh() {
            this.handleSearchHomework()
            setTimeout(() => {
                this.isLoading = false;
            }, 1000);
        }
    }

}
</script>

<style lang="scss" scoped>
.wrap{
  width: 100%;
  min-height: 100%;
  background: #f0f4f5;;
}
.header{
    box-sizing: border-box;
    padding: 0 10px 0 20px;
    background: #ffffff;
}
.search-box{
    padding: 8px 10px 8px;
    box-sizing: border-box;
    background-color: #F0F4F5;
    ::v-deep .van-search{
      padding: 0;
      border-radius: 18px;
    }
    ::v-deep .van-search__content{
      background-color: #FFFFFF;
    }
    ::v-deep .van-icon-search{
      font-weight: 700;
    }
    
    ::v-deep input[type=search]::placeholder {
            color: #7E8180;
    }
}
.main {
    width: 100%;
    box-sizing: border-box;
    padding: 0 12px;
    .homework-item {
        display: flex;
        padding: 12px;
        height: 127px;
        box-sizing: border-box;
        background-color: #ffffff;
        margin-bottom: 8px;
        border-radius: 8px;
        align-items: center;
        position: relative;
        justify-content: space-between;
        .homework-item-image {
            width: 154px;
            height: 103px;
            margin-right: 12px;
            img {
                border-radius: 4px;
                width: 100%;
                height: 100%;
            }
        }
        .homework-item-content {
            height: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 14px;
            color: #909399;
            .homework-item-title {
                .chapter {
                    font-size: 16px;
                    color: #202020;
                }
                .section {
                    margin-top: 4px;
                }
            }
            .homework-item-message {
                span {
                    color: #FF7D00;
                }
            }
        }
        .dot {
            background-color: #F53F3F;
            border: 2px solid #ffffff;
            border-radius: 50%;
            position: absolute;
            left: 4px;
            top: 4px;
            width: 12px; 
            height: 12px;
            color: #fff;
            border-radius: 50%;
        }
    }
}
.clamp2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
}
</style>